module.exports = __webpack_public_path__ + "static/khorshidnet-complete-74e15340edc393d73d38e7e50d6b908c.jpg";